/**
 * Loading Timeout Fix
 *
 * Ensures page finishes loading even if some resources fail or timeout
 * Prevents infinite loading spinner by force-completing after timeout
 */

(function() {
  'use strict';

  // Force hide preloader after maximum wait time (10 seconds)
  var MAX_LOAD_TIME = 10000;
  var loadStartTime = Date.now();

  // Timeout handler
  var loadTimeout = setTimeout(function() {
    console.warn('Loading timeout reached - forcing page ready state');
    forceCompleteLoad();
  }, MAX_LOAD_TIME);

  // Function to force complete the page load
  function forceCompleteLoad() {
    // Hide preloader if it exists
    var preloader = document.querySelector('.preloader');
    if (preloader) {
      preloader.classList.add('preloader--hide');
      preloader.style.display = 'none';
    }

    // Stop any loading animations
    document.body.classList.add('page-loaded');
    document.documentElement.classList.add('page-loaded');

    // Clear the timeout
    clearTimeout(loadTimeout);

    console.log('Page load forced complete after', Date.now() - loadStartTime, 'ms');
  }

  // Listen for actual page load completion
  if (document.readyState === 'complete') {
    clearTimeout(loadTimeout);
  } else {
    window.addEventListener('load', function() {
      clearTimeout(loadTimeout);
    });
  }

  // Also handle if DOM is already interactive
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    setTimeout(function() {
      clearTimeout(loadTimeout);
    }, 2000); // Give 2 more seconds after interactive
  }

})();
